import { type BroadcastChannelPort, createBroadcastChannel } from "./broadcast";

export const PREFERENCE_CHANNEL_NAME = "atd-preferences-v1";

const PREFERENCE_KEY_PREFIX = "atd:preferences:";

export const PREFERENCE_KEYS = {
  theme: `${PREFERENCE_KEY_PREFIX}theme`,
  navPosition: `${PREFERENCE_KEY_PREFIX}nav:position`,
  widgetGroupLinePosition: `${PREFERENCE_KEY_PREFIX}widget-group-line:position`,
} as const;

export interface PreferenceMessage {
  key: string;
  /** The raw string localStorage holds, so one parser serves both. */
  value: string;
}

export type PreferenceChannel = BroadcastChannelPort<PreferenceMessage>;

const parseMessage = (value: unknown): PreferenceMessage | undefined => {
  if (typeof value !== "object" || value === null) {
    return undefined;
  }
  if (
    !("key" in value) ||
    typeof value.key !== "string" ||
    !value.key.startsWith(PREFERENCE_KEY_PREFIX)
  ) {
    return undefined;
  }
  if (!("value" in value) || typeof value.value !== "string") {
    return undefined;
  }
  return { key: value.key, value: value.value };
};

export const createPreferenceChannel = (
  name = PREFERENCE_CHANNEL_NAME,
): PreferenceChannel => createBroadcastChannel(name, parseMessage);

let shared: PreferenceChannel | undefined;

/** Page-lifetime channel. Created on first use inside `/pro`, never at module scope. */
export const getPreferenceChannel = (): PreferenceChannel => {
  shared ??= createPreferenceChannel();
  return shared;
};

/** Test seam: drops the page-lifetime channel so a suite can start from nothing. */
export const resetPreferenceChannel = (): void => {
  shared?.close();
  shared = undefined;
};
